module.exports = {"width":120,"height":120,"entries":["card-frame-assist-star","card-frame-assist-norm","card-frame-0","card-frame-1","card-frame-2","card-frame-3","card-frame-4","card-overlay-0","card-overlay-1","card-overlay-2","card-overlay-3","card-overlay-4","card-bg","card-bg-2","card-bg-3","card-bg-4","card-bg-5"]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/card-frames.json
// module id = 272
// module chunks = 0